module.exports = __webpack_public_path__ + "static/img/EWallet-BuyPackage.d3bb455.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/backoffice/EWallet-BuyPackage.png
// module id = 5mhT
// module chunks = 0